import React from 'react';
import 'antd/dist/antd.css';
import './Popup.scss'
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import { CalendarTimeService } from '../../../services/calendar/calendar.tool.service.js';
import '../../../lib/Adaptation'

class Popup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    };

    componentDidMount() {
        let t = window.devicePixelRatio
        var Popup = document.getElementById("Popup");
        console.log(Popup, "Popup")
        Popup.style.transform = `translateY( ${-50 * t}px)`;

        //屏蔽右键
        $("#Popup").off('contextmenu').on('contextmenu', function (e) {
            return false;
        })

        // const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
        // __waterDocumentSvg({
        //     container: document.getElementById('Popup'),
        //     content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
        //     width: '700px',
        //     height: '550px',
        //     opacity: '0.1',
        //     fontSize: '26px',
        //     zIndex: 1000
        // })

    }

    render() {
        let { data } = this.props.data

        return (
            <div id="Popup" style={{ width: "100%", height: "100%", background: "#525658" }}>
                {/* <div id="box"></div> */}
                {/* <iframe id="ifm" src={data.file_url + "#scrollbars=0&toolbar=0&statusbar=0"} style={{ width: "100%", height: "100%" }}></iframe> */}
                <embed id="ifm" src={data.file_url} style={{ width: "100%", height: "106%" }}></embed>
            </div>
        )
    }
}
export default Popup;


// WEBPACK FOOTER //
// app/components/customPage/Popup/Popup.jsx